import "../css/app.scss"; // Assuming main.scss is in res/css
import Alpine from "alpinejs";
import { collapse } from "@alpinejs/collapse";

import { Notification } from "./alpine_stores/Notification";
import { Location } from "./alpine_stores/Location";
import { Application } from "./alpine_stores/Application";

import { SandhyaKala } from "./alpine_stores/SandhyaKala";
import { DarkMode } from "./alpine_stores/DarkMode";

/* Bootstrap Specific **/
import { Modal } from "bootstrap";
import { Offcanvas } from "bootstrap";
import { Date } from "./alpine_stores/Date";

import { Leaflet } from "./alpine_stores/Leaflet";
import { TimeZones } from "./alpine_stores/Timezones";
import { explanationPanel } from "./alpine_stores/explanationPanel";

import { setAppHeight } from "./setAppHeight";

import { registerSW } from "./serviceWorker";
import { pwa } from "./alpine_stores/pwa";
import { appVersion } from "./alpine_stores/appVersion";
import { appUpdater } from "./alpine_stores/appUpdater";
import { userPreferences } from "./alpine_stores/userPreferences";
import { uiTweaks } from "./alpine_stores/uiTweaks";
import onboarding from "./alpine_stores/onboarding";

document.querySelectorAll('[data-bs-toggle="modal"]').forEach((el) => {
  new Modal(el);
});

document.querySelectorAll('[data-bs-toggle="offcanvas"]').forEach((el) => {
  new Offcanvas(el);
});

/** End Bootstrap Specific */

document.addEventListener("alpine:init", () => {
  console.log("Starting Alpine Store allocation");

  const alpineStores = {

    userPreferences: userPreferences,
    pwa: pwa,
    timezones: TimeZones(),
    darkmode: DarkMode(),
    notification: Notification(),
    location: Location(),
    date: Date(),
    explanationPanel: explanationPanel,
    locationPicker: Leaflet(),
    // application: Application(),
    sandhyopasanam: SandhyaKala(),
    appVersion: appVersion,
    appUpdater: appUpdater,
    uiTweaks: uiTweaks,
    onboarding: onboarding,
  };

  for (const [storeName, storeObject] of Object.entries(alpineStores)) {
    console.log(storeName, storeObject);

    Alpine.store(storeName, storeObject);
  }
});

window.Alpine = Alpine;
Alpine.plugin(collapse)
Alpine.start();

document.addEventListener("DOMContentLoaded", setAppHeight);
window.addEventListener("resize", setAppHeight);
registerSW();
